module.exports = __webpack_public_path__ + "img/sonal-pro.f68eac24.jpg";